// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scroll[data-v-058ff7ea]{overflow-y:scroll}.v-btn:not(.v-btn--round).v-size--default.btn-search[data-v-058ff7ea]{height:40px!important;min-height:40px!important}[data-v-058ff7ea]::-webkit-scrollbar{-webkit-appearance:none;width:5px}[data-v-058ff7ea]::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5);border-radius:4px;box-shadow:0 0 1px hsla(0,0%,100%,.5)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
